/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import * as vp from 'vopay';
import { FunctionComponent, memo, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useStorage from '../../../hooks/useStorage';
import { useToken } from '../../../providers/Token.provider';
import { usePaylink } from '../../../providers/Paylink.provider';
import usePostLinkCreditCard from '../../../hooks/useApi/usePostLinkCreditCard';
import usePostLinkPushToCard from '../../../hooks/useApi/usePostLinkPushToCard';
import usePostPaylinkSetAccount from '../../../hooks/useApi/usePostPaylinkSetAccount';
import AgreePADContext, { AgreePADCtx } from '../CreditCard/Dialogue/AgreePADContext';
import AgreePADDialogue from '../CreditCard/Dialogue/AgreePADDialogue';
import { AgreePADDialogueHandler, DialogueHandlerPadProps } from '../CreditCard/Dialogue/types';
import styles from './SafeCharge.module.scss';
import { useFlexiblePayment } from '../../../providers/FlexiblePayment.provider';

import NuveiCreditCardContext, { NuveiCreditCardCtx } from './Dialogue/NuveiCreditCardContext';
import NuveiCreditCardDialogue from './Dialogue/NuveiCreditCardDialogue';
import { NuveiCreditCardDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import { useAccessTokenFields } from '../../../providers/AccessToken.provider';
import BrandingLogo from '../../UI/BrandingLogo/BrandingLogo';

type SafeChargeProps = {
  color: string;
  safeCharge: any;
  merchantId: string;
  merchantSiteId: string;
  type: string;
};

type DataProps = {
  method: string;
  origin: string;
};

type RespProps = {
  bin: string;
  cancelled: boolean;
  cavv: string;
  ccCardNumber: string;
  ccExpMonth: string;
  ccExpYear: string;
  dsTransID: string;
  eci: string;
  errCode: string;
  errorDescription: string;
  last4Digits: string;
  result: string;
  transactionId: string;
  transactionStatus: string;
  transactionType: string;
  userPaymentOptionId: string;
  xid: string;
};

type CardDetailsProps = {
  brand: string;
  cardType: string;
  clientRequestId: string;
  dccAllowed: boolean;
  errCode: number;
  internalRequestId: number;
  issuerCountry: string;
  merchantId: string;
  merchantSiteId: string;
  sessionToken: string;
  status: string;
  version: string;
};

const { Box, Button, Title, Term } = vp;

type FC = FunctionComponent<SafeChargeProps>;

export const SafeChargeCC: FC = memo((props: SafeChargeProps) => {
  const history = useHistory();
  const storage = useStorage();
  const { state } = useLocation<DataProps>();
  const { padInfo } = storage.padAgreement.getPadInfo();
  const { color, safeCharge, merchantId, merchantSiteId, type } = props;
  const { t } = useTranslation('translations', { keyPrefix: type === 'credit' ? 'CreditCardForm' : 'DebitCardForm' });
  const { token, isSetByBrowser, iQ11ForOnboarding } = useToken();
  const { Token } = usePaylink();
  const [cardN, setCardN] = useState(null);
  const [cardHolderName, setCardHolderName] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('');
  const [buttonDisableState, setButtonDisableState] = useState(false);
  const [shouldconnectNuveiCreditCard, setShouldconnectNuveiCreditCard] = useState(false);
  const [showNuveiCreditCardSuccessAlert, setShowNuveiCreditCardSuccessAlert] = useState(false);
  const [showNuveiCreditCardErrorAlert, setShowNuveiCreditCardErrorAlert] = useState(false);
  const [nuveiCreditCardError, setNuveiCreditCardError] = useState('');
  const [shouldLinkCreditCard, setShouldLinkCreditCard] = useState(false);
  const [shouldConnectCreditCard, setShouldConnectCreditCard] = useState(false);
  const [isLinkCreditCard, setIsLinkCreditCard] = useState(false);
  const [linkCreditCardResponse, postLinkCreditCard] = usePostLinkCreditCard({});
  const [linkPushToCardResponse, postLinkPushToCard] = usePostLinkPushToCard({});
  const [paylinkAccountResponse, setPaylinkAccount] = usePostPaylinkSetAccount({});
  const { paymentMethods, paymentType, addPaymentMethod, isFlexiblePayment, partialPaymentValues, installmentDetails } =
    useFlexiblePayment();
  const { accessToken } = useAccessTokenFields();

  const [showAgreePADSuccessAlert, setShowAgreePADSuccessAlert] = useState(false);
  const [hasAgreed, setHasAgreed] = useState(false);
  const [cardDetail, setCardDetails] = useState({
    brand: '',
    cardType: '',
    clientRequestId: '',
    dccAllowed: false,
    errCode: 0,
    internalRequestId: 0,
    issuerCountry: '',
    merchantId: '',
    merchantSiteId: '',
    sessionToken: '',
    status: '',
    version: '',
  });
  const [nuveiResp, setNuveiResp] = useState({
    bin: '',
    cancelled: false,
    cavv: '',
    ccCardNumber: '',
    ccExpMonth: '',
    ccExpYear: '',
    dsTransID: '',
    eci: '',
    errCode: '',
    errorDescription: '',
    last4Digits: '',
    result: '',
    transactionId: '',
    transactionStatus: '',
    transactionType: '',
    userPaymentOptionId: '',
    xid: '',
  });

  const NuveiCreditCard: NuveiCreditCardCtx = {
    showNuveiCreditCardSuccessAlert,
    showNuveiCreditCardErrorAlert,
    nuveiCreditCardError,
  };

  const AgreePAD: AgreePADCtx = {
    showAgreePADSuccessAlert,
  };

  const handlers = {
    handleConnectCreditCardDialogue: (handlerProps: DialogueHandlerProps<NuveiCreditCardDialogueHandler>) => {
      const { type: dialogueType, state: dialogueStatus, action = 'default' } = handlerProps;

      const dialogueHandlers: NuveiCreditCardDialogueHandler = {
        connect: {
          success: {
            default: () => {
              window.location.reload();
              setShowNuveiCreditCardSuccessAlert(false);
              storage.padAgreement.clearPadInfo();
            },
          },
          fail: {
            default: () => {
              setShowNuveiCreditCardErrorAlert(false);
              storage.padAgreement.clearPadInfo();
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[dialogueType][dialogueStatus];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
  };

  const handlersPad = {
    handleAgreePADDialogue: (handlerProps: DialogueHandlerPadProps<AgreePADDialogueHandler>) => {
      const { type: dialogueType, state: dialogueStatus, action = 'default' } = handlerProps;

      const dialogueHandlers: AgreePADDialogueHandler = {
        agree: {
          success: {
            default: () => {
              setHasAgreed(true);
              storage.padAgreement.storePadInfo('agreed');
              setShowAgreePADSuccessAlert(false);
            },
          },
          pdf: {
            default: () => {
              setShowAgreePADSuccessAlert(false);
            },
          },
          fail: {
            default: () => {
              setShowAgreePADSuccessAlert(false);
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[dialogueType][dialogueStatus];
      const handler = dialogueState[action] || dialogueState.default;
      handler();
    },
  };

  useEffect(() => {
    if (state?.method === 'debitcard') {
      storage.paymentMethod.storePaymentMethod('debitcard');
    } else {
      storage.paymentMethod.storePaymentMethod('credit');
    }
  }, []);

  const getCardDetail = () => {
    safeCharge.getCardDetails(
      {
        sessionToken: accessToken,
        merchantId,
        merchantSiteId,
        userPaymentOptionId: nuveiResp.userPaymentOptionId,
        useFields: 'true',
      },
      (resp: CardDetailsProps) => {
        setCardDetails(resp);
      },
    );
  };

  const createPayment = () => {
    setButtonDisableState(true);
    if (cardN) {
      try {
        safeCharge.createPayment(
          {
            // sessionToken will come from the /iq11/generate-embed-url response (in the AccessToken attribute).
            sessionToken: accessToken,
            cardHolderName,
            transactionType: 'Auth',
            paymentOption: cardN,
            billingAddress: {
              email,
              country,
            },
          },
          (resp: RespProps) => {
            setButtonDisableState(false);
            setShouldconnectNuveiCreditCard(true);

            setNuveiResp(resp);
            console.log('resp', resp);
          },
        );
      } catch (e) {
        console.error(e);
      }
    }
  };

  useEffect(() => {
    if (padInfo === 'agreed' && hasAgreed) {
      createPayment();
    }
  }, [padInfo]);
  useEffect(() => {
    if (shouldconnectNuveiCreditCard) {
      if (nuveiResp.result === 'APPROVED') {
        setShouldLinkCreditCard(true);
        getCardDetail();
      } else if (nuveiResp.result === 'ERROR') {
        setShowNuveiCreditCardErrorAlert(true);
        setNuveiCreditCardError(nuveiResp.errorDescription);
      } else if (nuveiResp.result === 'DECLINED') {
        setShowNuveiCreditCardErrorAlert(true);
        setNuveiCreditCardError(nuveiResp.result);
      }
    }
  }, [nuveiResp]);

  // '/credit-card/link-credit-card' || '/oct/link-card'
  useEffect(() => {
    if (shouldLinkCreditCard && nuveiResp.userPaymentOptionId !== '' && cardDetail.brand !== '') {
      if (state?.method === 'debitcard') {
        postLinkPushToCard({
          PaymentToken: nuveiResp.userPaymentOptionId,
          CardHolderName: cardHolderName,
          MaskedCardNumber: nuveiResp.ccCardNumber,
          CardBrand: cardDetail.brand,
          ExpiryYear: nuveiResp.ccExpYear,
          ExpiryMonth: nuveiResp.ccExpMonth,
          Email: email,
        });
      } else {
        postLinkCreditCard({
          PaymentToken: nuveiResp.userPaymentOptionId,
          CardHolderName: cardHolderName,
          MaskedCardNumber: nuveiResp.ccCardNumber,
          CardBrand: cardDetail.brand,
          ExpiryYear: nuveiResp.ccExpYear,
          ExpiryMonth: nuveiResp.ccExpMonth,
          Email: email,
          ForOnboarding: iQ11ForOnboarding || false,
        });
      }
    }
    setShouldConnectCreditCard(true);
  }, [shouldLinkCreditCard, cardDetail, nuveiResp]);

  const completePaylink = (connectionType: vp.ConnectionTypes) => {
    if (isFlexiblePayment) {
      if (paymentType === vp.FlexiblePaymentMethods.MultiplePaymentMethods) {
        const paymentMethodFind = paymentMethods.find((method) => method.method === connectionType);
        addPaymentMethod({
          ...paymentMethodFind,
          amount: paymentMethodFind?.amount || 0,
          token: linkCreditCardResponse.Token,
          account: nuveiResp.ccCardNumber || '',
          method: connectionType,
        });
        history.push('/connect/flexible-payment/multiple-payment-methods');
      }
      if (paymentType === vp.FlexiblePaymentMethods.PartialPayment) {
        storage.padAgreement.clearPadInfo();
        setPaylinkAccount({
          SingleUseToken: Token,
          Iq11Token: linkCreditCardResponse.Token,
          PaymentMethod: connectionType,
          FlexiblePaymentOptions: {
            PaymentOption: 'partial',
            PartialPaymentDetails: partialPaymentValues,
          },
        });
        setIsLinkCreditCard(true);
      }
      if (paymentType === vp.FlexiblePaymentMethods.InstallmentPlan) {
        storage.padAgreement.clearPadInfo();
        setPaylinkAccount({
          SingleUseToken: Token,
          Iq11Token: linkCreditCardResponse.Token,
          PaymentMethod: connectionType,
          FlexiblePaymentOptions: {
            PaymentOption: 'installments',
            InstallmentDetails: installmentDetails,
          },
        });
        setIsLinkCreditCard(true);
      }
    } else {
      storage.padAgreement.clearPadInfo();
      setPaylinkAccount({
        SingleUseToken: Token,
        Iq11Token: linkCreditCardResponse.Token,
        PaymentMethod: connectionType,
      });
      setIsLinkCreditCard(true);
    }
  };

  // 'paylink/set-account' after '/credit-card/link-credit-card'
  useEffect(() => {
    if (shouldConnectCreditCard) {
      setShouldConnectCreditCard(false);

      const { Success, ErrorMessage } = linkCreditCardResponse;
      if (!Success || (state?.origin !== 'token' && state?.origin !== 'iframe')) {
        setNuveiCreditCardError(ErrorMessage);
        setButtonDisableState(false);
        setShowNuveiCreditCardErrorAlert(true);
        return;
      }
      if (state?.origin === 'token') {
        completePaylink(vp.ConnectionTypes.Credit);
      } else {
        storage.padAgreement.clearPadInfo();
        if (isSetByBrowser) {
          const redirectMethod = token?.RedirectMethod;
          const url = `${token?.RedirectURL || ''}?Token=${linkCreditCardResponse.Token}&PaymentMethod=creditcard`;
          const Response = {
            Step: 'LINK',
            Url: url,
            CreditCardNumber: nuveiResp.ccCardNumber,
            CreditCardHolderName: cardHolderName,
            CreditCardBrand: '',
            CreditCardExpiryYear: nuveiResp.ccExpYear,
            CreditCardExpiryMonth: nuveiResp.ccExpMonth,
            Token: linkCreditCardResponse.Token,
            PaymentMethod: 'creditcard',
          };
          // inner and outer redirect
          window.top?.postMessage(Response, '*');
          if (window.parent && window.parent !== window.top) {
            window.parent.postMessage(Response, '*');
          }
          setTimeout(() => {
            if (isSetByBrowser) {
              if (redirectMethod === 'InnerRedirect') {
                window.location.href = url;
              } else if (redirectMethod === 'OuterRedirect') {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.top!.location.href = url;
              } else {
                history.push('/success');
              }
            }
          }, 300);
        } else {
          setShowNuveiCreditCardSuccessAlert(true);
        }
      }
    }
  }, [linkCreditCardResponse]);

  // 'paylink/set-account' after '/oct/link-card'
  useEffect(() => {
    if (shouldConnectCreditCard) {
      setShouldConnectCreditCard(false);

      const { Success, ErrorMessage } = linkPushToCardResponse;
      if (!Success || (state?.origin !== 'token' && state?.origin !== 'iframe')) {
        setNuveiCreditCardError(ErrorMessage);
        setButtonDisableState(false);
        setShowNuveiCreditCardErrorAlert(true);
        return;
      }

      if (state?.origin === 'token') {
        completePaylink(vp.ConnectionTypes.DebitCard);
      } else {
        storage.padAgreement.clearPadInfo();
        if (isSetByBrowser) {
          const redirectMethod = token?.RedirectMethod;
          const url = `${token?.RedirectURL || ''}?Token=${linkPushToCardResponse.Token}&PaymentMethod=debitcard`;
          const Response = {
            Step: 'LINK',
            Url: url,
            CreditCardNumber: nuveiResp.ccCardNumber,
            CreditCardHolderName: cardHolderName,
            CreditCardBrand: '',
            CreditCardExpiryYear: nuveiResp.ccExpYear,
            CreditCardExpiryMonth: nuveiResp.ccExpMonth,
            Token: linkPushToCardResponse.Token,
            PaymentMethod: 'debitcard',
          };
          // inner and outer redirect
          window.top?.postMessage(Response, '*');
          if (window.parent && window.parent !== window.top) {
            window.parent.postMessage(Response, '*');
          }
          setTimeout(() => {
            if (isSetByBrowser) {
              if (redirectMethod === 'InnerRedirect') {
                window.location.href = url;
              } else if (redirectMethod === 'OuterRedirect') {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.top!.location.href = url;
              } else {
                history.push('/success');
              }
            }
          }, 300);
        } else {
          setShowNuveiCreditCardSuccessAlert(true);
        }
      }
    }
  }, [linkPushToCardResponse]);

  useEffect(() => {
    if (isLinkCreditCard && paylinkAccountResponse) {
      setIsLinkCreditCard(false);
      if (paylinkAccountResponse.Success) {
        history.push('/thank-you');
      } else {
        setButtonDisableState(false);
        setShowNuveiCreditCardErrorAlert(true);
        setNuveiCreditCardError(paylinkAccountResponse.ErrorMessage);
      }
    }
  }, [paylinkAccountResponse]);

  useEffect(() => {
    if (safeCharge) {
      const safeChargeFields = safeCharge.fields({
        fonts: [
          { cssUrl: 'https://fonts.googleapis.com/css?family=Ubuntu:regular,500,bold,italic&subset=latin,latin-ext' },
        ],
        fontFamily: 'Ubuntu',
        locale: 'en',
        fontSize: '16px',
      });

      // Card number----------------------------------------------------
      const cardNumber = safeChargeFields.create('ccNumber', {
        style: {
          base: {
            fonts: [
              {
                cssUrl: 'https://fonts.googleapis.com/css?family=Ubuntu:regular,500,bold,italic&subset=latin,latin-ext',
              },
            ],
            fontFamily: 'Ubuntu',
            fontSize: '16px',
            '::placeholder': {
              color: 'transparent',
            },
          },
        },
      });
      cardNumber.attach('#card-number');

      // Card expiry date------------------------------------------------
      const cardExpiry = safeChargeFields.create('ccExpiration', {
        style: {
          base: {
            fonts: [
              {
                cssUrl: 'https://fonts.googleapis.com/css?family=Ubuntu:regular,500,bold,italic&subset=latin,latin-ext',
              },
            ],
            fontFamily: 'Ubuntu',
            fontSize: '16px',
            '::placeholder': {
              color: '#d3d3d3',
            },
          },
        },
      });
      cardExpiry.attach('#card-expiry');

      // CVV--------------------------------------------------------------
      const cardCvc = safeChargeFields.create('ccCvc', {
        style: {
          base: {
            fonts: [
              {
                cssUrl: 'https://fonts.googleapis.com/css?family=Ubuntu:regular,500,bold,italic&subset=latin,latin-ext',
              },
            ],
            fontFamily: 'Ubuntu',
            fontSize: '16px',
            '::placeholder': {
              color: 'transparent',
            },
          },
        },
      });
      cardCvc.attach('#card-cvc');
      setCardN(cardNumber);
    }
  }, [safeCharge]);

  return (
    <>
      <NuveiCreditCardContext.Provider value={NuveiCreditCard}>
        <div className={styles.container}>
          <Box flx="col" width="50%">
            <Box pb="lg" jc="center">
              {token?.BrandingDetails?.Logo && <BrandingLogo src={token?.BrandingDetails?.Logo} />}
            </Box>
            <Box mb="md" flx="col" height="auto">
              <Title title={`${t('title')}`} size="lg" bold />
            </Box>
            <div className={styles.item}>
              <label htmlFor="cardHolderName">{t('name')}</label>
              <span className={styles.required}>*</span>
              <input
                id="cardHolderName"
                name="cardHolderName"
                placeholder=""
                type="text"
                value={cardHolderName}
                onChange={(e) => setCardHolderName(e.target.value)}
              />
            </div>

            <div className={styles.item}>
              <label htmlFor="card-number">{t('cardNumber')}</label>
              <span className={styles.required}>*</span>
              <div id="card-number" className={[styles.input, styles.cardTextfield].join(' ')} />
            </div>

            <div className={styles.itemContainer}>
              <div className={styles.item}>
                <label htmlFor="card-expiry">{t('exp')}</label>
                <span className={styles.required}>*</span>
                <div id="card-expiry" className={[styles.input, styles.cardTextfield].join(' ')} />
              </div>

              <div className={styles.item}>
                <label htmlFor="card-cvc">{t('CVV')}</label>
                <span className={styles.required}>*</span>
                <div id="card-cvc" className={[styles.input, styles.cardTextfield].join(' ')} />
              </div>
            </div>

            <div className={styles.item}>
              <label htmlFor="email">{t('email')}</label>
              <span className={styles.required}>*</span>
              <input
                id="email"
                name="email"
                placeholder=""
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className={styles.item}>
              <label htmlFor="country">{t('country')}</label>
              <span className={styles.required}>*</span>
              <input
                id="country"
                name="country"
                placeholder="eg) CA"
                type="text"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>

            <Box mt="md" mb="lg" height="auto">
              <Term
                term={
                  <div>
                    {' '}
                    {t('termsStart')}{' '}
                    <a href="https://vopay.com/legal/services/tos/" target="_blank" rel="noreferrer">
                      {t('termsLink')}
                    </a>{' '}
                    {t('termsMiddle')}{' '}
                    <a href="https://vopay.com/legal/services/privacy-policy/" target="_blank" rel="noreferrer">
                      {t('termsLink2')}
                    </a>
                    . {t('termsEnd')}
                  </div>
                }
              />
            </Box>

            <div className={styles.item100}>
              <Button
                id="nuvei-credit-card-submit"
                label={`${t('continueButton')}`}
                type="submit"
                background={color}
                textColor={vp.getContrastColor(color)}
                width="100%"
                size="xlg"
                round
                bold
                noShadow
                isDisabled={buttonDisableState}
                isSubmitting={buttonDisableState}
                textSize={1}
                onClick={() => {
                  if (state?.method === 'debitcard') {
                    createPayment();
                  } else {
                    setShowAgreePADSuccessAlert(true);
                  }
                }}
              />
            </div>
          </Box>
        </div>
        <NuveiCreditCardDialogue handleDialogue={handlers.handleConnectCreditCardDialogue} type={type} />
      </NuveiCreditCardContext.Provider>
      <AgreePADContext.Provider value={AgreePAD}>
        <AgreePADDialogue handleDialogue={handlersPad.handleAgreePADDialogue} />
      </AgreePADContext.Provider>
    </>
  );
});
